import * as React from "react";
import { AppLayoutType } from "../AppLayout/AppLayout";
import { BackButton } from "../../util/Question/inputs/BackButton";
import { Block } from "baseui/block";
import { BrandLogo } from "../BrandLogo/BrandLogo";
import { ContactUsModal } from "../ContactUs/ContactUs";
import { ProgressBar, ProgressBarProps } from "kanopi-components/ProgressBar";
import { useAppLayoutContext } from "../AppLayout/appLayoutContext";
import { useNavigate } from "@reach/router";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export type TFlowLayoutProps = {
  steps: ProgressBarProps[];
  history: TQuestionSet[];
  defaultBackLocation?: string;
  prefix?: string;
  children: React.ReactNode;
};

export function FlowLayout({
  steps = [],
  history = [],
  defaultBackLocation,
  prefix = "/getquote",
  children,
}: TFlowLayoutProps) {
  const navigate = useNavigate();
  const [, theme] = useStyletron();
  const outerMargin = ["0px", "0px", theme.sizing.scale100];
  const onClick = () => {
    if (history.length > 1) {
      // The previous page is the 2nd last element in the history array, the last being the current page.
      const previousQuestionSetKey = history[history.length - 2].key;
      navigate(`${prefix}/${previousQuestionSetKey}`);
    } else {
      navigate(defaultBackLocation);
    }
  };
  const showBackButton = history.length > 1 || !!defaultBackLocation;
  const { setLayoutType } = useAppLayoutContext();
  React.useEffect(() => {
    setTimeout(() => {
      setLayoutType(AppLayoutType.Progress);
    });
  }, []);

  return (
    <Block width="100%">
      <Block
        marginTop={theme.sizing.scale400}
        paddingTop={theme.sizing.scale100}
        marginLeft={outerMargin}
        marginRight={outerMargin}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <BrandLogo />
        <ContactUsModal />
      </Block>
      {steps && (
        <Block marginTop={["0px", "0px", theme.sizing.scale0]}>
          <ProgressBar.Container>
            {steps.map(({ label, ...restProps }) => (
              <ProgressBar key={`progress-bar-${label}`} label={label} {...restProps} />
            ))}
          </ProgressBar.Container>
        </Block>
      )}
      {showBackButton && <BackButton onClick={onClick} />}
      <Block paddingTop={theme.sizing.scale1000}>{children}</Block>
    </Block>
  );
}
